<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeProcessingFileDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- CLOSED -->
    <div *ngIf="isClosed"
        class="d-flex flex-grow-1 flex-column align-items-center justify-content-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100"
        [class.zx-text-white]="isDarkMode">

        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            {{ "processing-file.by-by-1" | translate }}
        </h4>
        <span>{{ "processing-file.by-by-2" | translate }}</span>
        <button mat-raised-button (click)="instructionsInWhatsappForProgramm('Unknown')"
            class="rounded-pill zx-text-tiny zx-text-sm-small">
            <div class="w-100 h-100 d-flex align-items-center gap-2">
                <div class="whatsup-logo-container-small">
                    <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small">
                </div>
                <span>
                    {{'main-nav.contact-us' | translate}}
                </span>
            </div>
        </button>
    </div>

    <!-- OPEN -->
    <div *ngIf="!isClosed"
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100"
        [class.zx-text-white]="isDarkMode">

        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            <span>{{ "processing-file.pre-title.1" | translate }}</span>
            <span>{{ fileType }}</span>
            <span>{{ "processing-file.pre-title.2" | translate }}</span>
        </h4>

        <div class="d-flex flex-column align-items-center w-100 flex-grow-1 overflow-auto">
            <span class="spacer"></span>

            <span class="d-flex flex-column gap-1 gap-lg-2 w-100" style="max-width: 495px;" [class.zx-ltr]="!isRTL">
                <b class="text-green zx-text-medium zx-text-sm-big py-1 py-lg-2" [class.text-start]="!isRTL">
                    <span *ngIf="getVeryReducedFormat() !== 'PDF' && getVeryReducedFormat() !== 'JPEG'">
                        {{fileType}}
                    </span>
                    <span>
                        {{ "processing-file.title." + (getVeryReducedFormat() !== 'PDF' &&
                        getVeryReducedFormat() !== 'JPEG' ? "OTHER" :
                        getVeryReducedFormat()) | translate }}
                    </span>
                </b>
                <span *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                    {{ "processing-file.pdf.exp.1" | translate }}
                </span>
                <span *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                    {{ "processing-file.pdf.exp.2" | translate }}
                </span>
                <span *ngIf="fileType === 'JPEG'" [class.text-start]="!isRTL">
                    {{ "processing-file.jpeg.exp.1" | translate }}
                </span>
                <div class="d-flex zx-text-small zx-text-sm-medium" [class.text-start]="!isRTL">
                    <ul *ngIf="fileType === 'PDF'" class="pt-2" [class.text-start]="!isRTL">
                        <li class="pb-2">
                            {{ "processing-file.pdf.point-1" | translate }}
                        </li>
                        <li class="pb-2">
                            {{ "processing-file.pdf.point-2" | translate }}
                        </li>
                        <li class="pb-2 d-lg-none">
                            {{ "processing-file.pdf.point-3" | translate }}
                        </li>
                        <li class="d-lg-none">
                            {{ "processing-file.pdf.point-4" | translate }}
                        </li>
                    </ul>
                    <ul class="d-none d-lg-inline pt-2" *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                        <li class="pb-2">
                            {{ "processing-file.pdf.point-3" | translate }}
                        </li>
                        <li>
                            {{ "processing-file.pdf.point-4" | translate }}
                        </li>
                    </ul>
                </div>
                <b class="text-green zx-text-medium zx-text-sm-big py-2" [class.text-start]="!isRTL">
                    {{ "processing-file.why" | translate }}
                </b>
                <span class="text-green" *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                    <b>
                        {{ fileType }}
                    </b>
                    <b>
                        {{ "processing-file.pdf.exp.3-1" | translate }}
                    </b>
                    <span>
                        {{ "processing-file.pdf.exp.3-2" | translate }}
                    </span>
                </span>
                <span class="text-green" *ngIf="fileType === 'PDF'" [class.text-start]="!isRTL">
                    <b>
                        {{ "processing-file.pdf.exp.4-1" | translate }}
                    </b>
                    <span>
                        {{ "processing-file.pdf.exp.4-2" | translate }}
                    </span>
                </span>
                <span class="pt-2" [class.text-start]="!isRTL">
                    {{ "processing-file.exp.1.1" | translate }}
                </span>
                <b [class.text-start]="!isRTL">
                    {{ "processing-file.exp.1.2" | translate }}
                </b>
                <span class="pt-2" [class.text-start]="!isRTL">
                    {{ "processing-file.exp.1.3" | translate }}
                </span>

            </span>

            <span class="spacer"></span>
            <b class="pt-4 text-center text-sm-start text-green" [class.text-start]="!isRTL" [class.zx-ltr]="!isRTL">
                {{ "processing-file.end.1" | translate }}
            </b>
            <span *ngIf="language !== 'he'" class="pt-4 text-center text-sm-start text-green"
                [class.text-start]="!isRTL" [class.zx-ltr]="!isRTL">
                {{ "processing-file.only-he" | translate }}
            </span>
            <h4 class="text-center fw-bold m-0 pt-3 text-green" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                {{ "processing-file.end.2" | translate }}
            </h4>

        </div>

        <div class="d-flex flex-column w-100 row">
            <div class="col-12 col-lg-6 w-100 p-0 d-flex justify-content-center align-items-center">
                <div class="d-flex w-100 row">
                    <button (click)="instructionsInWhatsappForProgramm(pro)" *ngFor="let pro of programmArray1"
                        color="primary" mat-button
                        class="text-green rounded-2 zx-btn-single col-6 col-lg-3 fw-bold my-2">
                        {{ pro }}
                    </button>
                </div>
            </div>
            <div class="col-12 col-lg-6 w-100 p-0 d-flex justify-content-center align-items-center">
                <div class="d-flex w-100 row">
                    <button (click)="instructionsInWhatsappForProgramm(pro)" *ngFor="let pro of programmArray2"
                        color="primary" mat-button
                        class="text-green rounded-2 zx-btn-single col-6 col-lg-3 fw-bold my-2">
                        {{ pro }}
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>